import * as React from 'react';
import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { Editor } from './components/editor';
import { Home } from './components/home';
import { Result } from './components/result';
import { createStore } from '@common/utils/redux';
import { translationsEN } from './translations/en';
import { translationsES } from './translations/es';
import { translationsJA } from './translations/ja';
import { combineReducers } from 'redux';
import { mountReactNode } from '@common/utils/react';

const initComponent = function (componentId: string, locale: string, component: React.ReactNode) {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: translationsEN,
      ja: translationsES,
      es: translationsJA,
    };
  
    if (!translation[locale as keyof typeof translation]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
    
    mountReactNode(
      <Provider store={store}>
        {component}
      </Provider>,
      document.getElementById(componentId)!
    );
  } catch (err) {
    console.error(err);
  }
};

export const initDatasheetsEditor = (componentId: string, locale: string, context: number, formatId: number, tableFieldId: number) => {
  initComponent(componentId, locale, <Editor />);
};

export const initDatasheetsHome = (componentId: string, locale: string) => {
  initComponent(componentId, locale, <Home />);
};

export const initDatasheetsResult = (componentId: string, locale: string, context: number, formatId: number, tableFieldId: number, id: number) => {
  initComponent(componentId, locale, <Result />);
};
